<template>
    <div class="page-loading" v-if="isLoading">
      <font-awesome-icon :icon="['fad', 'spinner-third']" spin />
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingSpinner',
    props: {
      isLoading: {
        type: Boolean,
        required: true
      }
    }
  };
  </script>